@let lugar = this.lugar();

@if (dataSource.data.length === 0) {
  <p>No hay datos disponibles</p>
} @else {
  <div class="container">
    <table mat-table [dataSource]="dataSource">
      <ng-container  matColumnDef="descripcionArticulo">
        <th [ngClass]="{ 'white-header': lugar == 'home' }" mat-header-cell *matHeaderCellDef><b>{{ 'ULTIMOSTOCK.ARTICULO' | translate }}</b></th>
        <td mat-cell *matCellDef="let element">
          {{ element.descripcionArticulo }}
        </td>
      </ng-container>

      <ng-container matColumnDef="stock">
        <th [ngClass]="{ 'white-header': lugar == 'home' }" mat-header-cell *matHeaderCellDef><b>{{ 'ULTIMOSTOCK.STOCK_Teorico' | translate }}</b></th>
        <td
          mat-cell
          *matCellDef="let element"
          [ngClass]="{ 'red-text': element.stock < 0 }"
        >
          {{ element.stock }}
        </td>
      </ng-container>

      <ng-container matColumnDef="diasTeoricos">
        <th [ngClass]="{ 'white-header': lugar == 'home' }" mat-header-cell *matHeaderCellDef><b>{{ 'ULTIMOSTOCK.DIAS_STOCK_Teorico' | translate }}</b></th>
        <td
          mat-cell
          *matCellDef="let element"
          [ngClass]="{ 'red-text': element.diasTeoricos < 0 }"
        >
          {{ element.diasTeoricos }}
        </td>
      </ng-container>

      <ng-container matColumnDef="diasPactados">
        <th [ngClass]="{ 'white-header': lugar == 'home' }" mat-header-cell *matHeaderCellDef><b>{{ 'ULTIMOSTOCK.DIAS_STOCK_PACTADOS' | translate }}</b></th>
        <td
          mat-cell
          *matCellDef="let element"
          [ngClass]="{ 'red-text': element.diasPactados < 0 }"
        >
          {{ element.diasPactados }}
        </td>
      </ng-container>

      <ng-container matColumnDef="diferencia">
        <th [ngClass]="{ 'white-header': lugar == 'home' }" mat-header-cell *matHeaderCellDef><b>{{ 'ULTIMOSTOCK.DIFERENCIA' | translate }}</b></th>
        <td
          mat-cell
          *matCellDef="let element"
          [ngClass]="{ 'red-text': element.diferencia < 0 }"
        >
          {{ element.diferencia }}
        </td>
      </ng-container>

      <ng-container matColumnDef="sobrestock">
        <th [ngClass]="{ 'white-header': lugar == 'home' }" mat-header-cell *matHeaderCellDef><b>{{ 'ULTIMOSTOCK.SOBRESTOCK' | translate }}</b></th>
        <td
          mat-cell
          *matCellDef="let element"
          [ngClass]="{ 'red-text': element.sobrestock < 0 }"
        >
          {{ element.sobrestock }}
        </td>
      </ng-container>

      <ng-container matColumnDef="ventaMedia">
        <th [ngClass]="{ 'white-header': lugar == 'home' }" mat-header-cell *matHeaderCellDef><b>{{ 'ULTIMOSTOCK.VENTA_MEDIA' | translate }}</b></th>
        <td
          mat-cell
          *matCellDef="let element"
          [ngClass]="{ 'red-text': element.ventaMedia < 0 }"
        >
          {{ element.ventaMedia }}
        </td>
      </ng-container>

      <!-- Header Row -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <!-- Data Row -->
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
}
